import React, { useState, useEffect } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import {
  Avatar,
  Button,
  Hidden,
  Snackbar,
  Typography,
} from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { iconsDict } from "../../assets/icons/iconsDict.js";
import Icon from "../../fontIcons/icon";

import { useSelector } from "react-redux";
import useResizer from "./../../services/useResizer";
import CoinDetailStrip from "../CoinDetailStrip/index.js";

const InfoText = (props) => {
  const { label, value, declining, growth } = props;
  const classes = useStyles();
  return (
    <div className={classes.highlow}>
      <Typography
        variant="body2"
        display="block"
        className={classes.infoHeaderStyles}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        display="block"
        className={
          declining
            ? classes.declineStyles
            : growth
            ? classes.growthStyles
            : classes.defaultStyles
        }
      >
        {value}
      </Typography>
    </div>
  );
};

export default function TradeAppBar(props) {
  const prices = useSelector((state) => state.priceReducer.PRICES);

  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useResizer();
  let history = useHistory();
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);

  const [chartType, setChartType] = useState("");
  useEffect(() => {
    setChartType(props.coin.chartType);
  }, [props.coin.chartType]);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState({ title: "", content: "" });
  const [openDialog, setDialog] = useState(false);

  const handleClickOpen = (message) => {
    setMessage(message);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = () => {
    setDialog(true);
  };

  const handleDialogClose = () => {
    setDialog(false);
  };

  const token = useSelector((state) => state.trading.TOKEN);

  const { coin } = props;

  function goCryptoWallet(side) {
    if (token) {
      if (coin.config[`${side}Status`] === "ACTIVE") {
        history.push(`/wallet/crypto/${side}?coin=${coin.symbol}`);
      } else {
        if (side === "withdraw") {
          handleClickOpen({
            title:
              coin.config.withdrawStatus === "PAUSED"
                ? "Withdrawals Paused"
                : "Withdrawals Disabled",
            content:
              coin.config.withdrawStatus === "PAUSED"
                ? `Withdrawals for ${coin.symbol} are temporarily on hold. Please check back later.`
                : `Withdrawals for ${coin.symbol} are disabled.`,
          });
        } else {
          handleClickOpen({
            title:
              coin.config.depositStatus === "PAUSED"
                ? "Deposits Paused"
                : "Deposits Disabled",
            content:
              coin.config.depositStatus === "PAUSED"
                ? `Deposits for ${coin.symbol} are temporarily on hold. Please check back later.`
                : `Deposits for ${coin.symbol} are disabled.`,
          });
        }
      }
    } else {
      // alert("Pls login first");
      handleDialogOpen();
    }
  }

  return (
    <>
      <div className="md:hidden block mt-8">
        <CoinDetailStrip
          coin={coin.symbol}
          // help={true}
          // onHelpClick={handleDialogOpen}
          items={[
            {
              label: "24 hrs High",
              value: prices
                ? prices[`${coin.symbol}INR`]
                  ? chartType == "BUY_CHART"
                    ? prices[`${coin.symbol}INR`].hb
                    : prices[`${coin.symbol}INR`].hs
                  : null
                : "Loading",
            },
            {
              label: "24 hrs Low",
              value: prices
                ? prices[`${coin.symbol}INR`]
                  ? chartType == "BUY_CHART"
                    ? prices[`${coin.symbol}INR`].lb
                    : prices[`${coin.symbol}INR`].ls
                  : null
                : "Loading",
            },
          ]}
        ></CoinDetailStrip>
      </div>
      <div className="hidden md:block">
        <Paper
          square
          className={classes.wrapper}
          style={{ marginTop: !isMobile ? "10px" : "25px" }}
        >
          <Box
            className={`${classes.infobarStyles} justify-start md:gap-x-[12.5%] 2xl:gap-x-[25%]`}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                // marginLeft: "5px",
                // marginRight: "24px",
              }}
            >
              <img
                src={coinIcons?.[coin.symbol]?.activeIconUrl}
                height="auto"
                width={25}
                className="mr-2"
                alt={coin.symbol}
              />

              <div className={classes.coinName}>
                <p
                  style={{
                    fontSize: "16px",
                    marginTop: 0,
                    marginLeft: "5px",
                    marginBottom: 0,
                  }}
                >
                  {coinIcons?.[coin.symbol]?.["coinName"]}
                </p>
                <p
                  style={{
                    fontSize: "13px",
                    color: "#9fa1a0",
                    marginBottom: 0,
                    marginTop: 0,
                    marginLeft: "5px",
                  }}
                >
                  {coin.symbol}
                </p>
              </div>
            </div>

            {/* Commenting out until backend issue is fixed */}

            {chartType == "BUY_CHART" ? (
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "10px" }}>
                  <InfoText
                    label="24 hrs High"
                    value={
                      prices
                        ? prices[`${coin.symbol}INR`]
                          ? prices[`${coin.symbol}INR`].hb
                          : null
                        : "Loading"
                    }
                  />
                </div>
                <InfoText
                  label="24 hrs Low"
                  value={
                    prices
                      ? prices[`${coin.symbol}INR`]
                        ? prices[`${coin.symbol}INR`].lb
                        : null
                      : "Loading"
                  }
                />
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "10px" }}>
                  <InfoText
                    label="24 hrs High"
                    value={
                      prices
                        ? prices[`${coin.symbol}INR`]
                          ? prices[`${coin.symbol}INR`].hs
                          : null
                        : "Loading"
                    }
                  />
                </div>
                <InfoText
                  label="24 hrs Low"
                  value={
                    prices
                      ? prices[`${coin.symbol}INR`]
                        ? prices[`${coin.symbol}INR`].ls
                        : null
                      : "Loading"
                  }
                />
              </div>
            )}
            {/* <Hidden mdDown>
              <div className={classes.status}>
                <div className={classes.depo}>
                  <p
                    className={classes.link}
                    onClick={() => {
                      goCryptoWallet("deposit");
                    }}
                  >
                    Receive
                  </p>
                  <FiberManualRecordIcon
                    htmlColor={
                      coin.config
                        ? coin.config.depositStatus === "ACTIVE"
                          ? "green"
                          : "#DC4554"
                        : "white"
                    }
                    className={classes.recordIcon}
                  />
                </div>

                <div className={classes.with}>
                  <p
                    className={classes.link}
                    onClick={() => {
                      goCryptoWallet("withdraw");
                    }}
                  >
                    Send
                  </p>
                  <FiberManualRecordIcon
                    htmlColor={
                      coin.config
                        ? coin.config.withdrawStatus === "ACTIVE"
                          ? "green"
                          : "#DC4554"
                        : "white"
                    }
                    className={classes.recordIcon}
                  />
                </div>
              </div>
            </Hidden> */}
          </Box>
          {/* <Hidden mdUp>
            <div className={classes.status}>
              <div className={classes.depo}>
                <p
                  className={classes.link}
                  onClick={() => {
                    goCryptoWallet("deposit");
                  }}
                >
                  Receive
                </p>
                <FiberManualRecordIcon
                  htmlColor={
                    coin.config
                      ? coin.config.depositStatus === "ACTIVE"
                        ? "green"
                        : "#DC4554"
                      : "white"
                  }
                  className={classes.recordIcon}
                />
              </div>

              <div className={classes.with}>
                <p
                  className={classes.link}
                  onClick={() => {
                    goCryptoWallet("withdraw");
                  }}
                >
                  Send
                </p>
                <FiberManualRecordIcon
                  htmlColor={
                    coin.config
                      ? coin.config.withdrawStatus === "ACTIVE"
                        ? "green"
                        : "#DC4554"
                      : "white"
                  }
                  className={classes.recordIcon}
                />
              </div>
            </div>
          </Hidden> */}
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{message.title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {message.content}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                color="primary"
                variant="contained"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  marginRight: "17px",
                  marginBottom: "12px",
                }}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            style={{ minHeight: "500px" }}
          >
            <DialogTitle>{"Please Login or SignUp to continue"}</DialogTitle>
            <DialogActions
              style={{ paddingBottom: "30px", paddingRight: "20px" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  history.push(`/login`);
                }}
                style={{ color: "white", fontWeight: "bold" }}
              >
                Login
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  history.push(`/createacc`);
                }}
                color="primary"
                style={{ fontWeight: "bold" }}
              >
                Create an Account
              </Button>
            </DialogActions>
          </Dialog>
        </Paper>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    borderRadius: "25px !important",
    overflow: "hidden",
    boxShadow: "none !important",
    lineHeight: "25px",
    background: theme.palette.type === "dark" ? "#2D2F3E" : "white",
    // minWidth: "450px",
  },
  infobarStyles: {
    width: "100%",
    flexWrap: "wrap",
    // height: "73px",
    display: "flex",
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",
    paddingLeft: "12px", //12px
    paddingRight: "12px", //12px
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "5px", //5px
      paddingTop: "5px", //5px
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "10px", //10px
      paddingBottom: "10px", //10px
      alignItems: "top",
    },
  },
  coinName: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  highlow: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
    alignItems: "baseline",
  },
  status: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-10px",
      marginBottom: "10px",
    },
  },
  depo: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
      marginRight: "10px",
    },
  },
  with: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "14px",
    },
  },
  leftBarContainer: {
    flex: 3,
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "top",
    },
    flexDirection: "row",
  },
  centerBarContainer: {
    flex: 2,
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "top",
    },
    flexDirection: "row",
  },
  rightBarContainer: {
    flex: 2,
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "top",
    },
    flexDirection: "column",
  },
  infoHeaderStyles: {
    color: theme.palette.text.primary,
    opacity: 0.7,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      // marginRight: "5px",
      marginLeft: "10px",
    },
    fontSize: "13px",
    marginRight: "5px",
  },
  declineStyles: {
    color: theme.palette.error.light,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginLeft: "10px",
    },
    fontSize: "16px",
  },
  growthStyles: {
    color: theme.palette.success.main,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginLeft: "10px",
    },
    fontSize: "16px",
  },
  defaultStyles: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginLeft: "10px",
    },
    fontSize: "16px",
  },
  recordIcon: {
    fontSize: "14px",
    // marginTop: "8px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "4px",
    },
    // marginBottom: "6px"
  },
  notification: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      paddingBottom: "5px",
    },
  },
  styledAlert: {
    "& .MuiAlert-icon": {
      fontSize: 50,
      fontWeight: "bold",
    },
    fontSize: 15,
    fontWeight: "bold",
  },
  link: {
    fontSize: "13px",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));
